/** Integration API — Faz 1.4 createApi factory. Önce: 152 satır / 12 metot. Sonra. */
import {createApi} from './_factory'
import type {CommonNs, IntegrationNs, ProjectNs} from '@shared/types'

const integration = createApi('integration')
const oauthIntegration = createApi('oauth/integration')

export const IntegrationApi = {
  // — Read —
  getWorkspaceIntegrations: (data: IntegrationNs.IntegrationInfoRequest) =>
    integration.post<IntegrationNs.IntegrationInfoRequest, IntegrationNs.IntegrationInfo[]>('get-integration-count', data),
  getIntegratedProjects: (data: IntegrationNs.IntegrationInfoRequest) =>
    integration.post<IntegrationNs.IntegrationInfoRequest, IntegrationNs.IntegrationInfo>('get-integration-info', data),
  getNotIntegratedProjectsInWorkspace: (data: IntegrationNs.IntegrationInfoRequest) =>
    integration.post<IntegrationNs.IntegrationInfoRequest, ProjectNs.Project[]>('get-projects-in-workspace', data),
  getAllProjectsToIntegration: (data: IntegrationNs.IntegrationInfoRequest) =>
    integration.post<IntegrationNs.IntegrationInfoRequest, ProjectNs.Project[]>('get-projects-to-integrate', data),
  getAuthorizeUrl: (data: IntegrationNs.IntegrationInfoRequest) =>
    integration.post<IntegrationNs.IntegrationInfoRequest, string>('get-authorize-url', data),
  getIssueTypes: (data: IntegrationNs.GetIssueTypeRequest) =>
    integration.post<IntegrationNs.GetIssueTypeRequest, IntegrationNs.IntIssueType[]>('get-issue-types', data),

  // — Mutate —
  removeIntegration: (data: IntegrationNs.IntegrationInfoRequest) =>
    integration.post<IntegrationNs.IntegrationInfoRequest, IntegrationNs.IntegrationInfo[]>('remove-workspace-integration', data),
  removeProjectIntegration: (data: IntegrationNs.RemoveIntegrationRequest) =>
    integration.post<IntegrationNs.RemoveIntegrationRequest, CommonNs.AnyResponse>('remove-project-integration', data),
  completeIntegration: (data: IntegrationNs.ProjectIntegrationRequest) =>
    integration.post<IntegrationNs.ProjectIntegrationRequest, CommonNs.AnyResponse>('complete-integration', data),
  reimportIssues: (data: IntegrationNs.ProjectIntegrationReimportRequest) =>
    integration.post<IntegrationNs.ProjectIntegrationReimportRequest, CommonNs.AnyResponse>('reimport-issues', data),
  changeSyncType: (data: IntegrationNs.ChangeSyncTypeRequest) =>
    integration.post<IntegrationNs.ChangeSyncTypeRequest, CommonNs.AnyResponse>('change-sync-type', data),

  storeAzureCredentials: (data: IntegrationNs.StoreAzureCredentialsRequest) =>
    integration.post<IntegrationNs.StoreAzureCredentialsRequest, void>('azure-boards/store-credentials', data),

  // — OAuth callback (farklı resource) —
  confirmAuthentication: (data: IntegrationNs.ConfirmAuthenticationRequest) =>
    oauthIntegration.post<IntegrationNs.ConfirmAuthenticationRequest, CommonNs.AnyResponse>('confirm-authentication', data),
}
